import { FC } from 'react';

import { withEventScope } from '@repo/event-processor';
import { Button, menuTheme } from '@repo/ui/components/Buttons';
import ArrowRightIcon from '@repo/ui/components/Icon/ArrowRightIcon';
import { H5 } from '@repo/ui/components/Typography';
import { buildImageProxyUrl } from '@repo/utils/url';

import { FlexRow } from 'styles/layouts';

import { PreviewImage, PreviewWrapper, ProjectItemWrapper } from './style';
import { Preview, ProjectItemProps } from './types';

const getPreview = (preview: Preview): string => {
  return buildImageProxyUrl(`api/${preview.url}`, {
    width: preview.size.width,
    height: preview.size.height,
    scale: 2,
  });
};

const ProjectItem: FC<ProjectItemProps> = (props) => {
  const handleOnClick: React.MouseEventHandler<HTMLElement> = (event) => {
    event.stopPropagation();
    props.onClick();
  };

  return (
    <ProjectItemWrapper onClick={handleOnClick}>
      <PreviewWrapper>
        {props.preview.url && (
          <PreviewImage
            alt="Project preview"
            height="60px"
            src={getPreview(props.preview)}
            width="60px"
          />
        )}
      </PreviewWrapper>
      <FlexRow>
        <H5 noTextOverflow>{props.name}</H5>
      </FlexRow>
      <Button
        ariaLabel="Open project"
        height="32px"
        icon={{
          component: ArrowRightIcon,
        }}
        name="openProjectButton"
        theme={menuTheme}
        width="32px"
        onClick={handleOnClick}
      />
    </ProjectItemWrapper>
  );
};

export default withEventScope(ProjectItem, { module: 'projectItem' });
